import React from "react";

// A browser chrome wrapper so product visuals read as "this is a real site" rather than
// a floating screenshot. Used on the platform pages to show the widget in context.
function BrowserFrame({ d, url, children, className = "" }) {
    return (
        <div
            className={`rounded-[20px] border overflow-hidden transition-colors duration-300 ${
                d
                    ? "bg-[#111] border-white/[0.06] shadow-2xl shadow-black/40"
                    : "bg-white border-gray-200 shadow-xl shadow-gray-900/5"
            } ${className}`}
        >
            <div
                className={`flex items-center justify-between px-3 sm:px-5 py-2.5 sm:py-3 border-b ${
                    d ? "bg-white/[0.02] border-white/[0.06]" : "bg-gray-50 border-gray-200"
                }`}
            >
                <div className="flex items-center space-x-1.5 sm:space-x-2">
                    <div className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${d ? "bg-white/10" : "bg-black/10"}`} />
                    <div className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${d ? "bg-white/10" : "bg-black/10"}`} />
                    <div className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${d ? "bg-white/10" : "bg-black/10"}`} />
                </div>
                <div
                    className={`flex-1 max-w-xs mx-2 sm:mx-4 px-2 sm:px-4 py-1 rounded-full text-[10px] sm:text-xs text-center truncate ${
                        d ? "bg-white/[0.04] text-gray-600" : "bg-gray-100 text-gray-400"
                    }`}
                >
                    {url}
                </div>
                <div className="w-8 sm:w-16" />
            </div>
            {children}
        </div>
    );
}

export default BrowserFrame;
